export const getSelectedLocation = (selectedCountry) => {
    switch (selectedCountry) {
        case 'Poland':
            return 'Łódź';
        case 'Germany':
            return 'Frankfurt';
        case 'CzechRepublic':
            return 'Prague';
        case 'Bulgaria':
            return 'Sofia';
        default:
            return 'none';
    }
};

export const getSelectedCountry = (selectedLocation) => {
    const searchterm = String(selectedLocation).toLocaleLowerCase();
    switch (searchterm) {
        case 'Łódź'.toLocaleLowerCase():
            return 'Poland';
        case 'lodz'.toLocaleLowerCase():
            return 'Poland';
        case 'Frankfurt'.toLocaleLowerCase():
            return 'Germany';
        case 'Prague'.toLocaleLowerCase():
            return 'CzechRepublic';
        case 'Sofia'.toLocaleLowerCase():
            return 'Bulgaria';
        default:
            return undefined;
    }
};
